(() => {

    const loadCustomScripts = () => {
        window.custom_scripts.forEach(script => {
            let s = document.createElement('script');
            s.setAttribute('src', script);
            document.head.insertAdjacentElement("beforeend", s);
        });
    };

    const loadGTag = () => {
        let a = document.createElement('script');
        a.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=AW-1072314078');

        a.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());

            gtag('config', 'AW-1072314078');
        };
        document.head.insertAdjacentElement("beforeend", a);

        let s = document.createElement('script');
        s.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-3588134-1');

        s.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());

            gtag('config', 'UA-3588134-1', { 'optimize_id': 'GTM-5HNKWV4' });
        };
        document.head.insertAdjacentElement("beforeend", s);

        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-P872R4J');
    };

    const loadYotpo = () => {
        (function e() { var e = document.createElement("script"); e.type = "text/javascript", e.async = true, e.src = "//staticw2.yotpo.com/1pyQsasIqUP6T6NkU1bLXejp2RgkkLK6yvupBktV/widget.js"; var t = document.getElementsByTagName("script")[0]; t.parentNode.insertBefore(e, t) })();
    };

    const loadFreshChat = () => {
        function initialize(i, t) { var e; i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e)) } 
        function initiateCall() { initialize(document, "freshchat-js-sdk") } 
        window.addEventListener ? window.addEventListener("load", initiateCall, !1) : window.attachEvent("load", initiateCall, !1);
    };

    const loadWLM = () => {
        let a = document.createElement('script');
        a.setAttribute('src', 'https://www.escortradar.com/apps/wlm/js/wlm-1.1.js');

        a.onload = () => {
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('WLMLoaded'));
            }, 500);
        };
        document.head.insertAdjacentElement("beforeend", a);
    };

    const loadGoogleReviews = () => {
        let a = document.createElement('script');
        a.setAttribute('src', 'https://apis.google.com/js/platform.js?onload=renderOptIn');
        document.head.insertAdjacentElement("beforeend", a);
    };
    const addCartOpenListener = () => {
        document.addEventListener('cart:open', () => {
            //trigger cart listener for google optimize
            let cartMini = document.getElementById('mini-cart')
            let cartItems = cartMini = cartMini.querySelectorAll('[data-item]');
            const triggerOptimize = () => { dataLayer.push({'event': 'optimize.subs_in_cart'});}
            let itemsHasSubs = [];
            let itemsHasRadar = [];
            cartItems.forEach(item => {
                if (cartItems.length == 1){
                    if (item.getAttribute('data-item').includes('x80')){
                        itemsHasSubs.push(true)
                    }
                }
                //check for radar
                if (item.querySelector('[data-property="Subscription"]')){
                    itemsHasRadar.push(true)
                }
            })
            if (itemsHasSubs.length == 0 && itemsHasRadar.length > 0){
                triggerOptimize();
            }
        })
    }

    const loadScripts = () => {
        loadGTag();
        loadYotpo();
        loadFreshChat();
        loadWLM();
        loadGoogleReviews();
        loadCustomScripts();
        addCartOpenListener();
    };

    document.addEventListener('UserInteracted', loadScripts, false);
})();